import styled from "styled-components";

export const BrandImageStyledContainer = styled.div`
   width: 110px;
   cursor: pointer;
`;

export const BrandImageStyledComponent = styled.img`
   width: 100%;
   object-fit: contain;
`;
